import { CampaignCodesPage } from "@/components/campaign-codes";
import { requirePermission } from "@/lib/casl/route-guards";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/campaign-codes/")({
  component: CampaignCodes,
  beforeLoad: ({ context }) => {
    requirePermission(context.user, "read", "campaign-codes");
  },
});

function CampaignCodes() {
  return <CampaignCodesPage />;
}
